import {GRAY_LIGHT} from 'ui-library/Colors';

export const borderStyle = `1px solid ${GRAY_LIGHT}`;
